/**
 * Runtime configuration utility
 *
 * In production, configuration is injected at container startup via window.__RUNTIME_CONFIG__
 * In development, falls back to process.env.REACT_APP_* values
 */

interface RuntimeConfig {
  API_BASE_URL: string;
  BUGSNAG_KEY: string;
  APPLICATION_ID: string;
}

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RuntimeConfig;
  }
}

function isPlaceholder(value: string | undefined): boolean {
  return !value || (value.startsWith('__') && value.endsWith('__'));
}

function getConfig(): RuntimeConfig {
  const runtimeConfig = window.__RUNTIME_CONFIG__;

  return {
    API_BASE_URL: isPlaceholder(runtimeConfig?.API_BASE_URL)
      ? process.env.REACT_APP_API_BASE_URL || 'https://apibeta.movatic.co/v1'
      : runtimeConfig!.API_BASE_URL,
    BUGSNAG_KEY: isPlaceholder(runtimeConfig?.BUGSNAG_KEY)
      ? process.env.REACT_APP_BUGSNAG_KEY || ''
      : runtimeConfig!.BUGSNAG_KEY,
    APPLICATION_ID: isPlaceholder(runtimeConfig?.APPLICATION_ID)
      ? process.env.REACT_APP_APPLICATION_ID || ''
      : runtimeConfig!.APPLICATION_ID,
  };
}

export const runtimeConfig = getConfig();
